// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9e6ea7b4","952":"eb3e21d3"}[chunkId] + ".chunk.js";
};